/**
 * Asynchronously loads the component for HomePage
 */

import { lazyLoad } from 'app/utils/loadable';

export const DefaultPortfolioPage = lazyLoad(
  () => import('./index'),
  module => module.DefaultPortfolioPage,
);
